<mat-form-field appearance="fill" class="full-width" color="primary" floatLabel="auto">
  <mat-label>{{ label() }}</mat-label>
  <mat-chip-grid #chipGrid>
    @for (item of selected; track item) {
      <mat-chip-row (removed)="remove(item)">
        {{ item[nameProperty()] }}
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
  </mat-chip-grid>
  <input
    #input
    [formControl]="control"
    [matAutocomplete]="auto"
    [matChipInputFor]="chipGrid"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    [placeholder]="placeholder()"
    (blur)="onTouched()"
    (focusout)="clearInputValue()"
    (matChipInputTokenEnd)="clearInputValue()"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    autoActiveFirstOption
    (optionSelected)="onSelect($event)"
  >
    @for (item of filtered$ | async; track item) {
      @if (!isInList(item)) {
        <mat-option [value]="item">
          {{ item[nameProperty()] }}
        </mat-option>
      }
    }
  </mat-autocomplete>
</mat-form-field>
